import React from 'react';
import {findDOMNode} from "react-dom";

import PopoverComponent from "core/gd-components/base-component/popover-component";
import Popover from "src/core/gd-components/gd-popover/popover";
import TextEditPopoverForm from "../../../system/components/text-edit/text-edit-popover-form";

export default class StringInListWithPopover extends PopoverComponent {

    onSave = (value) => {
        this.setState({
            showPopover: false
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(false);
            if (this.props.onChange) this.props.onChange(value);
        })
    }

    renderPopover() {
        if (this.state.showPopover) {
            return (
                <Popover popoverClass="gd-field-text-edit-popover"
                         className="gd-field-text-edit-popover-container"
                         attachment={this.props.attachment ? this.props.attachment : 'top center'} //defaultProps somehow doesn't work
                         targetAttachment={this.props.targetAttachment ? this.props.targetAttachment : 'bottom center'}
                         targetOffset={this.props.targetOffset}
                         attachmentType={this.props.attachmentType ? this.props.attachmentType : 'horizontal'}
                         getTargetFunc={()=>findDOMNode(this)}
                         onClickOutside={()=>{this.hidePopover()}}>

                    <TextEditPopoverForm text={this.props.value} onSave={this.onSave}/>

                </Popover>
            );
        }
    }

    render() {
        const classes = Classes('gd-field-text','list', 'ui5-field-input-hover-border');

        return (
            <div className={classes} onClick={this.props.canEdit === false ? null : this.togglePopover}>
                {this.props.value}
                {this.renderPopover()}
            </div>
        )
    }
}
